import { ReactNode } from 'react';

import { Typography } from '../typography';

export const InfoFieldValue = ({
  value,
  disableTypography,
  truncate,
}: {
  value: ReactNode;
  disableTypography?: boolean;
  truncate?: boolean;
}) => {
  if (disableTypography) {
    return <>{value}</>;
  }

  return <Typography noWrap={truncate}>{value}</Typography>;
};
